// Zajednički stil stranice za štampu (react-to-print): A4 sa marginom na svim
// stranama. Podrazumevani pageStyle biblioteke postavlja marginu 0.
// Široki registri (rizika, kontrola, akcioni planovi) ga ne koriste dok se ne
// odluči o orijentaciji lista.
export const PRINT_PAGE_STYLE = `
  @page { size: A4; margin: 12mm; }
  @media print {
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;
